import { Injectable } from '@angular/core';
import {
  AccessMenuRoleDto,
  AccessMenuRole,
  MenuRolePayload,
} from '../../models/system-settings/manage-roles-menu.model';

@Injectable({
  providedIn: 'root',
})
export class MapperManageRolesMenuService {
  mapAccessMenuRoleFromDto(dto: AccessMenuRoleDto): AccessMenuRole {
    return {
      id: dto.id,
      name: dto.name || '',
      menuListId: dto.menuListId ?? 0,
      menuListName: dto.menuListName || '',
      groupMenuId: dto.groupMenuId ?? 0,
      groupMenuName: dto.groupMenuName || '',
      groupSubId: dto.groupSubId ?? 0,
      groupSubName: dto.groupSubName || '',
      roleId: dto.roleId ?? 0,
      roleName: dto.roleName || '',
      canView: dto.canView ?? false,
      canCreate: dto.canCreate ?? false,
      canEdit: dto.canEdit ?? false,
      canDelete: dto.canDelete ?? false,
      canAction: dto.canAction ?? false,
      createDate: dto.createDate ? new Date(dto.createDate) : null,
      writeDate: dto.writeDate ? new Date(dto.writeDate) : null,
    };
  }

  mapAccessMenuRoleToPayload(
    item: AccessMenuRole,
    userId: number,
    menuId: number
  ): MenuRolePayload {
    return {
      id: item.id,
      name: item.name || item.menuListName,
      menuListId: item.menuListId,
      roleId: item.roleId,
      canView: item.canView,
      canCreate: item.canCreate,
      canEdit: item.canEdit,
      canDelete: item.canDelete,
      canAction: item.canAction,
      userId,
      menuId,
    };
  }
}
